import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { defaultPieces, defaultServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import ContactForm from "@/pages/home/components/ContactForm";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Hero from "./components/Hero";
import ServicesGrid from "./components/ServicesGrid";
import RepairNotReplace from "./components/RepairNotReplace";
import FloatingButton from "./components/FloatingButton";

export default function NosPrestationsPage() {
  useSEO(seoData.nosPrestations);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...defaultPieces} />
        <ServicesSection {...defaultServices} />
        <ServicesGrid />
        <RepairNotReplace />
        <GoogleReviews />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}